export function getTickets (state) {
  return state.tickets
}

export function getTicket (state) {
  return state.ticket
}
